import { useTranslation } from 'react-i18next'
import { AnimatePresence } from 'motion/react'
import { useContextPanels } from '../../contexts/panelsContext'
import QRCodeDialog from '../QRCodeDialog'
import legalPages from './legalPages'

// The open legal page as a QR code, for the kiosk that can't open the museum's site
const LegalNotice = () => {
  const { t } = useTranslation()
  const { panelState, closePanel } = useContextPanels()
  const page = panelState.legalPage

  return (
    <AnimatePresence>
      {page ? (
        <QRCodeDialog
          // switching pages swaps the dialogs instead of changing the content in place
          key={page}
          title={t(legalPages[page].dialogTitleKey)}
          description={t('legalPages.description')}
          qrCodes={[{ value: legalPages[page].link }]}
          onClose={() => closePanel(page)}
        />
      ) : null}
    </AnimatePresence>
  )
}

export default LegalNotice
